import { ref } from 'vue'

// 全局小屏断点：窗口宽度低于该值时视为 iPad / 小屏布局
export const IPAD_BREAKPOINT = 1200
export const MAX_IPAD_BREAKPOINT = 1401

const updateIsIpad = () => {
  window.isIpad.value = window.innerWidth < IPAD_BREAKPOINT
  window.isMaxIpad.value = window.innerWidth < MAX_IPAD_BREAKPOINT
}

export const initScreenConfig = () => {
  window.isIpad = ref(window.innerWidth < IPAD_BREAKPOINT)
  window.isMaxIpad = ref(window.innerWidth < MAX_IPAD_BREAKPOINT)
  window.addEventListener('resize', updateIsIpad)
}
